import { ApiError } from "@gwrctl/api-client";

/**
 * Ham hatayı kullanıcıya gösterilecek Türkçe cümleye çevirir. Ekranda
 * "Failed to fetch", "HTTP 502" ya da JSON dökümü görünmesin.
 */
export function humanizeError(error: unknown, fallback = "Bir şeyler ters gitti"): string {
  if (error instanceof ApiError) {
    if (error.status === 401) return "Oturumun düştü; yeniden giriş yapman gerekiyor.";
    if (error.status === 403) {
      return error.message && error.message !== `HTTP 403`
        ? error.message
        : "Bu işlem için yetkin yok ya da doğrulama kodu gerekiyor.";
    }
    if (error.status === 404) return "Aranan kayıt bulunamadı (silinmiş olabilir).";
    if (error.status === 429) return "Çok sık istek gönderildi; birkaç saniye sonra tekrar dene.";
    if (error.status >= 500 && /^HTTP \d+$/.test(error.message)) {
      return "Sunucu şu an yanıt veremiyor. Birazdan tekrar dene.";
    }
    return error.message || fallback;
  }
  if (error instanceof TypeError && /fetch|network|load failed/i.test(error.message)) {
    return "Sunucuya ulaşılamadı. İnternet bağlantını ya da sunucunun durumunu kontrol et.";
  }
  if (error instanceof Error) return error.message || fallback;
  if (typeof error === "string") return error;
  return fallback;
}
